var _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _g5, _path7, _g6, _path8, _g7, _path9, _g8, _path0, _g9, _path1, _g0, _path10, _g1, _path11, _g10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 167,
    viewBox: "0 0 159 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.49 129.66V77.7896H114.35L62.49 129.66Z",
    fill: "#E0DFFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_41_494",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: 63,
    width: 53,
    height: 53
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.35 115.4V63.5298H120.22L68.35 115.4Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_41_494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.676 49.011L54.1462 151.541L55.6241 153.018L158.154 50.4889L156.676 49.011Z",
    fill: "#FFB624"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_41_494",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: 63,
    width: 53,
    height: 53
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.35 115.4V63.5298H120.22L68.35 115.4Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_41_494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.214 44.555L49.6847 147.084L51.1625 148.562L153.692 46.0328L152.214 44.555Z",
    fill: "#FFB624"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_41_494",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: 63,
    width: 53,
    height: 53
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.35 115.4V63.5298H120.22L68.35 115.4Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_41_494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.753 40.1082L45.2234 142.638L46.7013 144.116L149.231 41.586L147.753 40.1082Z",
    fill: "#FFB624"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_41_494",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: 63,
    width: 53,
    height: 53
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.35 115.4V63.5298H120.22L68.35 115.4Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_41_494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.305 35.6473L40.776 138.177L42.2538 139.655L144.783 37.1251L143.305 35.6473Z",
    fill: "#4540E1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_41_494",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: 63,
    width: 53,
    height: 53
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68.35 115.4V63.5298H120.22L68.35 115.4Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_41_494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.844 31.1951L36.3146 133.725L37.7925 135.202L140.322 32.6729L138.844 31.1951Z",
    fill: "#4540E1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_41_494",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: 63,
    width: 53,
    height: 53
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68.35 115.4V63.5298H120.22L68.35 115.4Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_41_494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.397 26.7391L31.8672 129.269L33.3451 130.746L135.875 28.2169L134.397 26.7391Z",
    fill: "#4540E1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_41_494",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: 63,
    width: 53,
    height: 53
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.35 115.4V63.5298H120.22L68.35 115.4Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_41_494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.935 22.2776L27.4056 124.807L28.8835 126.285L131.413 23.7555L129.935 22.2776Z",
    fill: "#4540E1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_41_494",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: 63,
    width: 53,
    height: 53
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68.35 115.4V63.5298H120.22L68.35 115.4Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_41_494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.474 17.8226L22.9442 120.352L24.4221 121.83L126.952 19.3004L125.474 17.8226Z",
    fill: "#4540E1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_41_494",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: 63,
    width: 53,
    height: 53
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M68.35 115.4V63.5298H120.22L68.35 115.4Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_41_494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.026 13.3631L18.4967 115.893L19.9745 117.37L122.504 14.8409L121.026 13.3631Z",
    fill: "#4540E1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_41_494",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: 63,
    width: 53,
    height: 53
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M68.35 115.4V63.5298H120.22L68.35 115.4Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_41_494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.565 8.91337L14.0353 111.443L15.5132 112.921L118.043 10.3912L116.565 8.91337Z",
    fill: "#FFB624"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_41_494",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: 63,
    width: 53,
    height: 53
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68.35 115.4V63.5298H120.22L68.35 115.4Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_41_494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.103 4.45683L9.57391 106.986L11.0518 108.464L113.581 5.93467L112.103 4.45683Z",
    fill: "#FFB624"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_41_494",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: 63,
    width: 53,
    height: 53
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M68.35 115.4V63.5298H120.22L68.35 115.4Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_41_494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.656 0.000288904L5.12653 102.53L6.60436 104.008L109.134 1.47813L107.656 0.000288904Z",
    fill: "#FFB624"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.43b87c8e953ce22b3b60d369d0d9b920.svg";
export { ForwardRef as ReactComponent };